import { userHasPermission } from 'services/Authorization';

export const isFeatureAccessible = ({
  checkIfFeatureFlagEnabled,
  featureFlag,
  permission,
  user
}) => {
  if (!user || (!featureFlag && !permission)) return false;

  if (checkIfFeatureFlagEnabled(featureFlag)) return true;

  return userHasPermission(permission, user);
};
